import React, { Component } from 'react';
import i18n from '../../i18n';
import './AppFooter.css';

class AppFooter extends Component {
  render() {
    return <div dangerouslySetInnerHTML={{ __html: i18n.getFooter() }} />;
  }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/AppFooter/index.js